import React from 'react';

interface MedicationProfileDirtyContextType {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
}

export const useMedicationProfileDirty = () => {
  return React.useContext(MedicationProfileDirtyContext);
};

const MedicationProfileDirtyContext =
  React.createContext<MedicationProfileDirtyContextType>({
    isDirty: false,
    setIsDirty: () => {},
  });

const MedicationProfileDirtyProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isDirty, setIsDirty] = React.useState(false);
  return (
    <MedicationProfileDirtyContext.Provider value={{ isDirty, setIsDirty }}>
      {children}
    </MedicationProfileDirtyContext.Provider>
  );
};

export default MedicationProfileDirtyProvider;
